<!-------------------------------------- Page Layout ---------------------------------------------->
<div class="container">
  <!-------------------------------------- Page Title ---------------------------------------------->
  <h1 class="pageTitle-responsive"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-file-excel" aria-hidden="true"></i></span>{{ 'DOAbnormal.Header' | translate }}
  </h1>

  <!-------------------------------------- Desktop Layout ---------------------------------------------->
  <p-card *ngIf="isInDesktopMode(); else mobileLayout">
    <ng-content *ngTemplateOutlet="desktopContent"></ng-content>
  </p-card>

  <!-------------------------------------- Mobile Layout ---------------------------------------------->
  <ng-template #mobileLayout>
    <p-card *ngIf="!isInDesktopMode()">
      <ng-content *ngTemplateOutlet="mobileContent"></ng-content>
    </p-card>
  </ng-template>

</div>

<!-------------------------------------- Desktop Content ---------------------------------------------->
<ng-template #desktopContent>
  <p-accordion [multiple]="true">

    <!-------------------------------------- Query Form ---------------------------------------------->
    <p-accordionTab
      header="{{ 'Common.Form.Header' | translate }}"
      [(selected)]="isSearchFormOpen"
    >
      <ng-content *ngTemplateOutlet="queryFormTemplate"></ng-content>
    </p-accordionTab>

    <!-------------------------------------- Header Table ---------------------------------------------->
    <p-accordionTab
      header="{{ 'DOAbnormal.Table.Header.Header' | translate }}"
      [(selected)]="isHeaderTableOpen"
    >
      <ng-content *ngTemplateOutlet="headerTableTemplate"></ng-content>
    </p-accordionTab>

    <!-------------------------------------- Detail Table ---------------------------------------------->
    <p-accordionTab
      header="{{ 'DOAbnormal.Table.Detail.Header' | translate }}"
      [(selected)]="isDetailTableOpen"
    >
      <ng-content *ngTemplateOutlet="detailTableTemplate"></ng-content>
    </p-accordionTab>

    <!-------------------------------------- Abnormal Item Table ---------------------------------------------->
    <p-accordionTab
      header="{{ 'DOAbnormal.Table.AbnormalItem.Header' | translate }}"
      [(selected)]="isAbnormalItemTableOpen"
    >
      <ng-content *ngTemplateOutlet="abnormalItemTableTemplate"></ng-content>
    </p-accordionTab>

  </p-accordion>
</ng-template>

<!-------------------------------------- Mobile Content ---------------------------------------------->
<ng-template #mobileContent>
  <p-tabView [(activeIndex)]="mobileTabPanelActiveIndex">
    <!-------------------------------------- Query Form ---------------------------------------------->
    <p-tabPanel
      header="{{ 'Common.Form.Header' | translate }}"
    >
      <ng-content *ngTemplateOutlet="queryFormTemplate"></ng-content>
    </p-tabPanel>

    <!-------------------------------------- Header Table ---------------------------------------------->
    <p-tabPanel
      header="{{ 'DOAbnormal.Table.Header.Header' | translate }}"
    >
      <ng-content *ngTemplateOutlet="headerTableTemplate"></ng-content>
    </p-tabPanel>

    <!-------------------------------------- Detail Table ---------------------------------------------->
    <p-tabPanel
      header="{{ 'DOAbnormal.Table.Detail.Header' | translate }}"
    >
      <ng-content *ngTemplateOutlet="detailTableTemplate"></ng-content>
    </p-tabPanel>

    <!-------------------------------------- Abnormal Item Table ---------------------------------------------->
    <p-tabPanel
      header="{{ 'DOAbnormal.Table.AbnormalItem.Header' | translate }}"
    >
      <ng-content *ngTemplateOutlet="abnormalItemTableTemplate"></ng-content>
    </p-tabPanel>
  </p-tabView>
</ng-template>

<!-------------------------------------- Query Form ---------------------------------------------->
<ng-template #queryFormTemplate>
  <form
    [formGroup]="searchFormGroup"
  >

    <!-------------------------------------- Form Field ---------------------------------------------->
    <div class="p-fluid formgrid grid">
      <!-------------------------------------- Order Type Field ---------------------------------------------->
      <div class="field col-12">
        <h3 for="formOrderQueryScope">{{ 'DOAbnormal.Form.Field.OrderQueryScope' | translate }}</h3>
        <div class="formgroup-inline">
          <div class="field-checkbox">
            <p-radioButton
              inputId="formOrderQueryScope"
              name="orderQueryScope"
              [value]="OrderQueryScopeEnum.personal"
              label="{{ 'DOAbnormal.Form.RadioButton.PersonalOrder' | translate }}"
              formControlName="orderQueryScope"
            ></p-radioButton>
          </div>
          <div class="field-checkbox">
            <p-radioButton
              inputId="formOrderQueryScope"
              name="orderQueryScope"
              [value]="OrderQueryScopeEnum.includeDepartment"
              label="{{ 'DOAbnormal.Form.RadioButton.IncludeDepartmentOrder' | translate }}"
              formControlName="orderQueryScope"
            ></p-radioButton>
          </div>
        </div>
      </div>

      <!-------------------------------------- Facility Field ---------------------------------------------->
      <div class="field col-12 md:col-6">
        <h3 for="formFacility">{{ 'DOAbnormal.Form.Field.Facility' | translate }}</h3>
        <laas-facility-dropdown
            formControlName="facilities"
            [isMultiple]="true"
            [showFilter]="true"
            [showToggleAll]="true"
          >
        </laas-facility-dropdown>
      </div>

      <!-------------------------------------- Customer Field ---------------------------------------------->
      <div class="field col-12 md:col-6" [ngClass]="{ 'p-invalid': checkRequiredField() }">
        <h3 for="formCustomer">{{ 'DOAbnormal.Form.Field.Customer' | translate }}</h3>
        <laas-customer-dropdown
          formControlName="customers"
          [divClass]="'field'"
          [showToggleAll]="false"
          [isMultiple]="true"
          [showLabel]="false"
        ></laas-customer-dropdown>
      </div>

      <!-------------------------------------- Do No Field ---------------------------------------------->
      <div class="field col-12 md:col-6">
        <h3 for="formDoNo">{{ 'DOAbnormal.Form.Field.DoNo' | translate }}</h3>
        <p-chips #doNoChips
          inputId="formDoNo"
          formControlName="doNos"
          separator=","
          (input)="addItemByComma($event, doNoChips)"
          (onAdd)="doNoChipsAdded($event)"
          [addOnTab]="true"
          [styleClass]="checkRequiredField() ? 'p-invalid' : ''"
        ></p-chips>
      </div>

      <!-------------------------------------- Invoice No Field ---------------------------------------------->
      <div class="field col-12 md:col-6">
        <h3 for="formInvoiceNo">{{ 'DOAbnormal.Form.Field.InvoiceNo' | translate }}</h3>
        <p-chips #invoiceNoChips
          inputId="formInvoiceNo"
          formControlName="invoiceNos"
          separator=","
          (input)="addItemByComma($event, invoiceNoChips)"
          (onAdd)="invoiceNoChipsAdded($event)"
          [addOnTab]="true"
          [styleClass]="checkRequiredField() ? 'p-invalid' : ''"
        ></p-chips>
      </div>

      <!-------------------------------------- ETD Field ---------------------------------------------->
      <div class="field col-12 laas-calendar mb-3">
        <laas-calendar
          #etdDt
          [class]="'col-12 md:col-6 mt-3'"
          [title]="'DOAbnormal.Form.Field.EstimatedTimeofDeparture'"
          [placeholder]="'DOAbnormal.Form.Placeholder.OptionHint.SelectStartAndEndDate'"
          [isH3Title]="true"
          [minDate]="etdMinDate"
          [enableMaxDateIsToday]="false"
          [showCustomButtonBar]="true"
          [validateFunction]="checkRequiredField"
          [showRangeMode]="true"
          [showStartMode]="true"
          (onDateChange)="dateOnChange($event, 'etdDt')">
        </laas-calendar>
      </div>

      <!-------------------------------------- Notified Field ---------------------------------------------->
      <div class="field col-12 md:col-6">
        <label for="formNotified">{{ 'DOAbnormal.Form.Field.Notified' | translate }}</label>
        <p-dropdown
          appendTo="body"
          inputId="formNotified"
          placeholder="{{ 'DOAbnormal.Form.Placeholder.OptionHint.SelectANotifyStatus' | translate }}"
          formControlName="notified"
          [showClear]="true"
          [options]="emailMarkOptions"
        ></p-dropdown>
      </div>

      <!-------------------------------------- Replied Field ---------------------------------------------->
      <div class="field col-12 md:col-6">
        <label for="formReplied">{{ 'DOAbnormal.Form.Field.Replied' | translate }}</label>
        <p-dropdown
          appendTo="body"
          inputId="formReplied"
          placeholder="{{ 'DOAbnormal.Form.Placeholder.OptionHint.SelectAReplyStatus' | translate }}"
          formControlName="replied"
          [showClear]="true"
          [options]="emailMarkOptions"
        ></p-dropdown>
      </div>

      <div class="field col-12">
        <small><strong class="p-invalid">
          {{ 'DOAbnormal.Form.Warning.NotifiedAndRepliedWarning' | translate }}
        </strong></small>
      </div>

    </div>

    <!-------------------------------------- Form Button ---------------------------------------------->
    <div>

      <!-------------------------------------- Query Button ---------------------------------------------->
      <button pButton
        label="{{ 'Common.Button.Search' | translate }}"
        (click)="searchBtnClick()"
      ></button>

      <!-------------------------------------- Reset Button ---------------------------------------------->
      <button pButton
        label="{{ 'Common.Button.Reset' | translate }}"
        class="p-button-secondary ml-2"
        (click)="resetSearchForm()"
      ></button>

    </div>
  </form>
</ng-template>

<!-------------------------------------- Header Table ---------------------------------------------->
<ng-template #headerTableTemplate>
  <p-table #headerTable
    laasDataTableSetting
    class="datatable"
    [tableKey]="headerPreferenceKey"
    [defaultColumns]="columnGroupOfheaderTable"
    (setPageSize)="setHeaderPageSize($event)"
    [selectable]="true"
    [value]="dataOfheaderTable"
    [loading]="isHeaderTableLoading"
    [resizableColumns]="true"
    [reorderableColumns]="true"

    [scrollable]="true"
    scrollHeight="500px"

    selectionMode="single"

    [lazy]="true"
    (onPage)="pagingOnHeaderTable($event)"
    (onSort)="sortingOnHeaderTable($event)"

    [paginator]="true"
    [paginatorPosition]="isInDesktopMode() ? 'bottom': 'top'"
    [showCurrentPageReport]="isInDesktopMode()"
    [showJumpToPageDropdown]="!isInDesktopMode()"
    [showPageLinks]="isInDesktopMode()"
    [showFirstLastIcon]="isInDesktopMode()"
    currentPageReportTemplate="{{ isInDesktopMode() ? ( 'Common.Table.PageSummary' | translate ) :  '{currentPage} of {totalPages}' }}"
    [rows]="this.pageInfoOfHeaderTable.pageSize"
    [rowsPerPageOptions]="this.rowsPerPageOptionsOfHeaderTable"
    [totalRecords]="this.pageInfoOfHeaderTable.totalRecords"

    [responsive]="true"
    dataKey="dataKey"
    editMode="row"
    styleClass="p-datatable-gridlines p-datatable-stripped white-space: nowrap;"
  >

    <!-------------------------------------- Header Table Caption Part ---------------------------------------------->
    <ng-template pTemplate="caption">
      <div class="caption flex flex-wrap justify-content-start">

        <!-------------------------------------- Header Table Display Columns Filter ---------------------------------------------->
        <div *ngIf="isInDesktopMode()">
          <laas-table-column-toggle
            [optionsColumn]="columnGroupOfheaderTable"
            [dataTable]="headerTable">
          </laas-table-column-toggle>
        </div>

        <!-------------------------------------- Header Table Select All Button ---------------------------------------------->
        <div *ngIf="!isInDesktopMode()">
          <button pButton
            class="p-button-info p-button-raised"
            label="{{ 'DOAbnormal.Table.Button.SelectAll' | translate }}"
            [ngClass]="!isInDesktopMode() ? '' : 'p-button ml-2'"
            (click)="toggleAllRowCheckboxOnHeaderTable()"
          ></button>
        </div>

        <!-------------------------------------- Header Table Notify Button ---------------------------------------------->
        <laas-permission-button permissionCode="DOAbnormalSendNotification"
          [class]="'p-button-success p-button-raised' + (!isInDesktopMode() ? '' : 'ml-2')"
          label="{{ 'DOAbnormal.Table.Header.Button.Notify' | translate }}"
          [disabled]="this.checkedRowOfHeaderTable.length <= 0"
          (onClick)="askConfirmationForSendNotification()"
        ></laas-permission-button>

        <!-------------------------------------- Header Table Reply Button ---------------------------------------------->
        <laas-permission-button permissionCode="DOAbnormalReplyNotification"
          [class]="'p-button-success p-button-raised' + (!isInDesktopMode() ? '' : 'ml-2')"
          label="{{ 'DOAbnormal.Table.Header.Button.Reply' | translate }}"
          [disabled]="this.checkedRowOfHeaderTable.length <= 0"
          (onClick)="askConfirmationForReplyNotification()"
        ></laas-permission-button>

        <!-------------------------------------- Header Table Save Button ---------------------------------------------->
        <laas-permission-button permissionCode="DOAbnormalEdit"
          [class]="'p-button-raised' + (!isInDesktopMode() ? '' : 'ml-2')"
          label="{{ 'Common.Button.Save' | translate }}"
          [disabled]="!isHeaderTableInEditMode"
          (onClick)="saveDataChangesOnHeaderTable()"
        ></laas-permission-button>

        <!-------------------------------------- Header Table Restore Button ---------------------------------------------->
        <laas-permission-button permissionCode="DOAbnormalEdit"
          [class]="'p-button-secondary p-button-raised' + (!isInDesktopMode() ? '' : 'ml-2')"
          label="{{ 'DOAbnormal.Table.Button.Restore' | translate }}"
          [disabled]="!isHeaderTableInEditMode"
          (onClick)="restoreDataOnHeaderTable()"
        ></laas-permission-button>

        <!-------------------------------------- Header Table Edit Button ---------------------------------------------->
        <laas-permission-button permissionCode="DOAbnormalEdit"
          style="color: white;"
          [class]="'p-button-warning p-button-raised' + (!isInDesktopMode() ? '' : 'ml-2')"
          label="{{ isHeaderTableInEditMode ? ( 'Common.Button.Cancel' | translate ) : ( 'Common.Button.Edit' | translate ) }}"
          [disabled]="!isAbleToEdit()"
          (click)="switchEditModeOnHeaderTable()"
        ></laas-permission-button>

      </div>
    </ng-template>

    <!-------------------------------------- Header Table Column Group Part ---------------------------------------------->
    <ng-template pTemplate="colgroup" let-columns>
      <colgroup *ngIf="isInDesktopMode()">
        <col style="width: 50px;">
        <col *ngFor="let col of columns" [style]="{ width: col.width + 'px' }">
      </colgroup>
    </ng-template>

    <!-------------------------------------- Header Table Column Header Part ---------------------------------------------->
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th scope="col">
          <p-checkbox
            #headerCheckboxOfHeaderTable
            (click)="toggleAllRowCheckboxOnHeaderTable()"
            [binary]="true">
          </p-checkbox>
        </th>
        <th *ngFor="let col of columns" pReorderableColumn pResizableColumn
          [pSortableColumn]="col.field"
          [pSortableColumnDisabled]="!col.sort"
          scope="col"
          [attr.field]="col.field">
          <div class="flex">
            {{ col.header | translate }}
            <column-filter [tableColumn]="col"></column-filter>
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </div>
        </th>
      </tr>
    </ng-template>

    <!-------------------------------------- Header Table Body Part ---------------------------------------------->
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr [pSelectableRow]="rowData" [pEditableRow]="rowData" (click)="selectRowOnHeaderTable(rowData)">
        <td *ngIf="isInDesktopMode()">
          <p-checkbox
            #rowCheckboxOfHeaderTable
            (click)="stopBubblingPhases($event)"
            (onChange)="toggleRowCheckboxOnHeaderTable($event, rowData)"
            [binary]="true">
          </p-checkbox>
        </td>
        <ng-container [ngSwitch]="col.field" *ngFor="let col of columns">

          <!-------------------------------------- Spec Loc Type Column ---------------------------------------------->
          <td *ngSwitchCase="'specLocType'">
            <div class="tableDataTitle-responsive field flex justify-content-between" *ngIf="!isInDesktopMode()">
              <div class="pr-5">{{ col.header | translate }}</div>
              <p-checkbox
                #rowCheckboxOfHeaderTable
                (click)="stopBubblingPhases($event)"
                (onChange)="toggleRowCheckboxOnHeaderTable($event, rowData)"
                [binary]="true">
              </p-checkbox>
            </div>
            <div class="tableData-responsive field overflow-text">
              {{ rowData[col.field] | replaceNullWith: "-" }}
            </div>
          </td>

          <!-------------------------------------- Waiting Reference Column ---------------------------------------------->
          <td *ngSwitchCase="'waitingReference'">
            <div class="tableDataTitle-responsive field">
              {{ col.header | translate }}
            </div>
            <p-cellEditor class="p-fluid">
              <ng-template pTemplate="input">
                <p-dropdown
                  appendTo="body"
                  inputId="headerTableWaitingReference"
                  placeholder="{{ 'DOAbnormal.Placeholder.OptionHint.SelectAWaitingReference' | translate }}"
                  [showClear]="true"
                  [filter]="true"
                  [options]="waitingReferenceOptions"
                  (click)="stopBubblingPhases($event)"
                  [(ngModel)]="rowData[col.field]"
                ></p-dropdown>
              </ng-template>
              <ng-template pTemplate="output">
                <div class="tableData-responsive field overflow-text">
                  {{ getWaitingReferenceDescByItsCode(rowData[col.field]) | replaceNullWith: "-" }}
                </div>
              </ng-template>
            </p-cellEditor>
          </td>

          <!-------------------------------------- ETA Column ---------------------------------------------->
          <td *ngSwitchCase="'eta'">
            <div class="tableDataTitle-responsive field">
              {{ col.header | translate }}
            </div>
            <div class="tableData-responsive field overflow-text">
              {{ rowData[col.field] | date: 'YYYY-MM-dd HH:mm:ss' | replaceNullWith: "-" }}
            </div>
          </td>

          <!-------------------------------------- ETD Column ---------------------------------------------->
          <td *ngSwitchCase="'etd'">
            <div class="tableDataTitle-responsive field">
              {{ col.header | translate }}
            </div>
            <div class="tableData-responsive field overflow-text">
              {{ rowData[col.field] | date: 'YYYY-MM-dd HH:mm:ss' | replaceNullWith: "-" }}
            </div>
          </td>

          <!-------------------------------------- Notify Date Column ---------------------------------------------->
          <td *ngSwitchCase="'notifyDt'">
            <div class="tableDataTitle-responsive field">
              {{ col.header | translate }}
            </div>
            <div class="tableData-responsive field overflow-text">
              {{ rowData[col.field] | date: 'YYYY-MM-dd HH:mm:ss' | replaceNullWith: "-" }}
            </div>
          </td>

          <!-------------------------------------- Notify Flag Column ---------------------------------------------->
          <td *ngSwitchCase="'notifyFlag'">
            <div class="tableDataTitle-responsive field">
              {{ col.header | translate }}
            </div>
            <div class="tableData-responsive field overflow-text">
              {{ rowData[col.field] | optionsMapping: emailMarkOptions | replaceNullWith: "-" }}
            </div>
          </td>

          <!-------------------------------------- Reply Date Column ---------------------------------------------->
          <td *ngSwitchCase="'replyDt'">
            <div class="tableDataTitle-responsive field">
              {{ col.header | translate }}
            </div>
            <div class="tableData-responsive field overflow-text">
              {{ rowData[col.field] | date: 'YYYY-MM-dd HH:mm:ss' | replaceNullWith: "-" }}
            </div>
          </td>

          <!-------------------------------------- Reply Flag Column ---------------------------------------------->
          <td *ngSwitchCase="'replyFlag'">
            <div class="tableDataTitle-responsive field">
              {{ col.header | translate }}
            </div>
            <div class="tableData-responsive field overflow-text">
              {{ rowData[col.field] | optionsMapping: emailMarkOptions | replaceNullWith: "-" }}
            </div>
          </td>

          <td *ngSwitchDefault>
            <div class="tableDataTitle-responsive field">
              {{ col.header | translate }}
            </div>
            <div class="tableData-responsive field overflow-text">
              {{ rowData[col.field] | replaceNullWith: "-" }}
            </div>
          </td>

        </ng-container>
      </tr>
      <br *ngIf="!isInDesktopMode()">
    </ng-template>

    <!-------------------------------------- Header Table Empty Message Part ---------------------------------------------->
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td></td>
        <td [attr.colspan]="columns.length">
          {{ 'Common.Table.NoData' | translate }}
        </td>
      </tr>
    </ng-template>

  </p-table>
</ng-template>

<!-------------------------------------- Detail Table ---------------------------------------------->
<ng-template #detailTableTemplate>
  <p-table #detailTable
    laasDataTableSetting
    class="datatable"
    [tableKey]="detailPreferenceKey"
    [defaultColumns]="columnGroupOfDetailTable"
    (setPageSize)="setDetailPageSize($event)"
    [selectable]="true"
    [columns]="selectedColumnsOfDetailTable"
    [value]="dataOfDetailTable"
    [loading]="isDetailTableLoading"
    [resizableColumns]="true"
    [reorderableColumns]="true"

    [scrollable]="true"
    scrollHeight="500px"

    [(selection)]="selectedRowOfDetailTable"
    selectionMode="single"

    [lazy]="true"
    (onPage)="pagingOnDetailTable($event)"
    (onSort)="sortingOnDetailTable($event)"

    [paginator]="true"
    [paginatorPosition]="isInDesktopMode() ? 'bottom': 'top'"
    [showCurrentPageReport]="isInDesktopMode()"
    [showJumpToPageDropdown]="!isInDesktopMode()"
    [showPageLinks]="isInDesktopMode()"
    [showFirstLastIcon]="isInDesktopMode()"
    currentPageReportTemplate="{{ isInDesktopMode() ? ( 'Common.Table.PageSummary' | translate ) :  '{currentPage} of {totalPages}' }}"
    [rows]="this.pageInfoOfDetailTable.pageSize"
    [rowsPerPageOptions]="this.rowsPerPageOptionsOfDetailTable"
    [totalRecords]="this.pageInfoOfDetailTable.totalRecords"

    [responsive]="true"
    dataKey="dataKey"
    styleClass="p-datatable-gridlines p-datatable-stripped white-space: nowrap;"
  >
    <!-------------------------------------- Detail Table Caption Part ---------------------------------------------->
    <ng-template pTemplate="caption">
      <div class="caption flex flex-wrap justify-content-start">

        <!-------------------------------------- Detail Table Display Columns Filter ---------------------------------------------->
        <div *ngIf="isInDesktopMode()">
          <laas-table-column-toggle
            [optionsColumn]="columnGroupOfDetailTable"
            [dataTable]="detailTable">
          </laas-table-column-toggle>
        </div>

        <!-------------------------------------- Detail Table Select All Button ---------------------------------------------->
        <div *ngIf="!isInDesktopMode()">
          <button pButton
            class="p-button-info p-button-raised"
            label="{{ 'DOAbnormal.Table.Button.SelectAll' | translate }}"
            [ngClass]="!isInDesktopMode() ? '' : 'p-button ml-2'"
            (click)="toggleAllRowCheckboxOnDetailTable()"
          ></button>
        </div>

        <!-------------------------------------- Detail Table Upload Button -------------------------------------->
        <div *ngIf="this.permissionCodes.includes(this.DOAbnormalUpload)">
          <button pButton
            class="p-button-success p-button-raised"
            label="{{ 'DOAbnormal.Table.Detail.Button.Upload' | translate }}"
            [ngClass]="!isInDesktopMode() ? '' : 'p-button ml-2'"
            [disabled]="!isAbleToUpload()"
            (click)="showUploadFileDialog()"
          ></button>
        </div>

      </div>
    </ng-template>

    <!-------------------------------------- Detail Table Column Group Part ---------------------------------------------->
    <ng-template pTemplate="colgroup" let-columns>
      <colgroup *ngIf="isInDesktopMode()">
        <col style="width: 50px;">
        <col *ngFor="let col of columns" [style]="{ width: col.width + 'px' }">
      </colgroup>
    </ng-template>

    <!-------------------------------------- Detail Table Column Header Part ---------------------------------------------->
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th scope="col">
          <p-checkbox
            #headerCheckboxOfDetailTable
            (click)="toggleAllRowCheckboxOnDetailTable()"
            [binary]="true">
          </p-checkbox>
        </th>
        <th *ngFor="let col of columns" pReorderableColumn pResizableColumn
          [pSortableColumn]="col.field"
          [pSortableColumnDisabled]="!col.sort"
          scope="col"
          [attr.field]="col.field">
          <div class="flex">
            {{ col.header | translate }}
            <column-filter [tableColumn]="col"></column-filter>
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </div>
        </th>
      </tr>
    </ng-template>

    <!------------------------------------------- Detail Table Body Part -------------------------------------------->
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr
        (click)="selectRowOnDetailTable()"
        [pSelectableRow]="rowData"
        [style]="rowData.isRelated ?
          rowData == this.selectedRowOfDetailTable ? 'background-color: black; color: white;' : 'background-color: red; color: white;'
          : ''"
      >
        <td *ngIf="isInDesktopMode()">
          <p-checkbox
            #rowCheckboxOfDetailTable
            (click)="stopBubblingPhases($event)"
            (onChange)="toggleRowCheckboxOnDetailTable($event, rowData)"
            [binary]="true">
          </p-checkbox>
        </td>

        <ng-container [ngSwitch]="col.field" *ngFor="let col of columns">

          <!-------------------------------------- SKU Column ---------------------------------------------->
          <ng-container *ngIf="!isInDesktopMode()">
            <td *ngSwitchCase="'sku'">
              <div class="tableDataTitle-responsive field flex justify-content-between">
                <div class="pr-5">{{ col.header | translate }}</div>
                <p-checkbox
                  #rowCheckboxOfDetailTable
                  (click)="stopBubblingPhases($event)"
                  (onChange)="toggleRowCheckboxOnDetailTable($event, rowData)"
                  [binary]="true">
                </p-checkbox>
              </div>
              <div class="tableData-responsive field overflow-text">
                {{ rowData[col.field] | replaceNullWith: "-" }}
              </div>
            </td>
          </ng-container>

          <td *ngSwitchCase="'receivedDt'">
            <div class="tableDataTitle-responsive field">
              {{ col.header | translate }}
            </div>
            <div class="tableData-responsive field overflow-text">
              {{ rowData[col.field] | date: 'YYYY-MM-dd HH:mm:ss' | replaceNullWith: "-" }}
            </div>
          </td>

          <td *ngSwitchDefault>
            <div class="tableDataTitle-responsive field">
              {{ col.header | translate }}
            </div>
            <div class="tableData-responsive field overflow-text">
              {{ rowData[col.field] | replaceNullWith: "-" }}
            </div>
          </td>

        </ng-container>
      </tr>
      <br *ngIf="!isInDesktopMode()">
    </ng-template>

    <!-------------------------------------- Detail Table Empty Message Part ---------------------------------------------->
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td></td>
        <td [attr.colspan]="columns.length">
          {{ 'Common.Table.NoData' | translate }}
        </td>
      </tr>
    </ng-template>

  </p-table>
</ng-template>

<!-------------------------------------- Abnormal Item Table ---------------------------------------------->
<ng-template #abnormalItemTableTemplate>
  <p-table #abnormalItemTable
    laasDataTableSetting
    class="datatable"
    [tableKey]="abnormalItemPreferenceKey"
    [defaultColumns]="columnGroupOfAbnormalItemTable"
    (setPageSize)="setAbnormalItemPageSize($event)"
    [selectable]="true"
    [columns]="selectedColumnsOfAbnormalItemTable"
    [value]="dataOfAbnormalItemTable"
    [loading]="isAbnormalItemTableLoading"
    [resizableColumns]="true"
    [reorderableColumns]="true"

    [scrollable]="true"
    scrollHeight="500px"

    selectionMode="single"

    [lazy]="true"
    (onPage)="pagingOnAbnormalItemTable($event)"
    (onSort)="sortingOnAbnormalItemTable($event)"

    [paginator]="true"
    [paginatorPosition]="isInDesktopMode() ? 'bottom': 'top'"
    [showCurrentPageReport]="isInDesktopMode()"
    [showJumpToPageDropdown]="!isInDesktopMode()"
    [showPageLinks]="isInDesktopMode()"
    [showFirstLastIcon]="isInDesktopMode()"
    currentPageReportTemplate="{{ isInDesktopMode() ? ( 'Common.Table.PageSummary' | translate ) :  '{currentPage} of {totalPages}' }}"
    [rows]="this.pageInfoOfAbnormalItemTable.pageSize"
    [rowsPerPageOptions]="this.rowsPerPageOptionsOfAbnormalItemTable"
    [totalRecords]="this.pageInfoOfAbnormalItemTable.totalRecords"

    [responsive]="true"
    (onRowUnselect)="reselectAfterEnterKeyDown($event)"
    dataKey="dataKey"
    editMode="row"
    styleClass="p-datatable-gridlines p-datatable-stripped white-space: nowrap;"
  >

    <!-------------------------------------- Abnormal Item Table Caption Part ---------------------------------------------->
    <ng-template pTemplate="caption">
      <div class="caption flex flex-wrap justify-content-start">

        <!-------------------------------------- Abnormal Item Table Display Columns Filter ---------------------------------------------->
        <div *ngIf="isInDesktopMode()">
          <laas-table-column-toggle
            [optionsColumn]="columnGroupOfAbnormalItemTable"
            [dataTable]="abnormalItemTable">
          </laas-table-column-toggle>
        </div>

        <!-------------------------------------- Abnormal Item Table Select All Button ---------------------------------------------->
        <div *ngIf="!isInDesktopMode()">
          <button pButton
            class="p-button-info p-button-raised"
            label="{{ 'DOAbnormal.Table.Button.SelectAll' | translate }}"
            [ngClass]="!isInDesktopMode() ? '' : 'p-button ml-2'"
            (click)="toggleAllRowCheckboxOnAbnormalItemTable()"
          ></button>
        </div>

        <!-------------------------------------- Abnormal Item Table Add Button ---------------------------------------------->
        <div *ngIf="this.permissionCodes.includes(this.DOAbnormalEdit)">
          <button pButton *ngIf="isTenant"
            class="p-button-success p-button-raised"
            label="{{ 'Common.Button.Add' | translate }}"
            [ngClass]="!isInDesktopMode() ? '' : 'p-button ml-2'"
            [disabled]="!isAbnormalItemTableInEditMode || !this.selectedRowOfHeaderTable"
            (click)="addRowOnAbnormalItemTable()"
          ></button>
        </div>

        <!-------------------------------------- Abnormal Item Table Delete Button ---------------------------------------------->
        <div *ngIf="this.permissionCodes.includes(this.DOAbnormalEdit)">
          <button pButton *ngIf="isTenant"
            class="p-button-danger p-button-raised"
            label="{{ 'Common.Button.Delete' | translate }}"
            [ngClass]="!isInDesktopMode() ? '' : 'p-button ml-2'"
            [disabled]="!isAbnormalItemTableInEditMode || dataOfAbnormalItemTable.length <= 0 || !this.selectedRowOfHeaderTable"
            (click)="deleteRowOnAbnormalItemTable()"
          ></button>
        </div>

        <!-------------------------------------- Abnormal Item Table Save Button ---------------------------------------------->
        <div *ngIf="this.permissionCodes.includes(this.DOAbnormalEdit)">
          <button pButton
            class="p-button-raised"
            label="{{ 'Common.Button.Save' | translate }}"
            [ngClass]="!isInDesktopMode() ? '' : 'p-button ml-2'"
            [disabled]="!isAbnormalItemTableInEditMode || !this.selectedRowOfHeaderTable"
            (click)="saveDataChangesOnAbnormalItemTable()"
          ></button>
        </div>

        <!-------------------------------------- Abnormal Item Table Restore Button ---------------------------------------------->
        <div *ngIf="this.permissionCodes.includes(this.DOAbnormalEdit)">
          <button pButton
            class="p-button-secondary p-button-raised"
            label="{{ 'DOAbnormal.Table.Button.Restore' | translate }}"
            [ngClass]="!isInDesktopMode() ? '' : 'p-button ml-2'"
            [disabled]="!isAbnormalItemTableInEditMode || !this.selectedRowOfHeaderTable"
            (click)="restoreDataOnAbnormalItemTable()"
          ></button>
        </div>

        <!-------------------------------------- Abnormal Item Table Edit Button ---------------------------------------------->
        <div *ngIf="this.permissionCodes.includes(this.DOAbnormalEdit)">
          <button pButton
            style="color: white;"
            class="p-button-warning p-button-raised"
            label="{{ isAbnormalItemTableInEditMode ? ( 'Common.Button.Cancel' | translate ) : ( 'Common.Button.Edit' | translate ) }}"
            [ngClass]="!isInDesktopMode() ? '' : 'p-button ml-2'"
            [disabled]="!isAbleToEdit()"
            (click)="switchEditModeOnAbnormalItemTable()"
          ></button>
        </div>

      </div>
    </ng-template>

    <!-------------------------------------- Abnormal Item Column Group Part ---------------------------------------------->
    <ng-template pTemplate="colgroup" let-columns>
      <colgroup *ngIf="isInDesktopMode()">
        <col style="width: 50px;">
        <col *ngFor="let col of columns" [style]="{ width: col.width + 'px' }">
      </colgroup>
    </ng-template>

    <!-------------------------------------- Abnormal Item Table Column Header Part ---------------------------------------------->
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th scope="col">
          <p-checkbox
            #headerCheckboxOfAbnormalItemTable
            (click)="toggleAllRowCheckboxOnAbnormalItemTable()"
            [binary]="true">
          </p-checkbox>
        </th>
        <th *ngFor="let col of columns" pReorderableColumn pResizableColumn
          [pSortableColumn]="col.field"
          [pSortableColumnDisabled]="!col.sort"
          scope="col"
          [attr.field]="col.field">
          <div class="flex">
            {{ col.header | translate }}
            <column-filter [tableColumn]="col"></column-filter>
            <p-sortIcon [hidden]="!col.sort" [field]="col.field"></p-sortIcon>
          </div>
        </th>
      </tr>
    </ng-template>

    <!------------------------------------------- Abnormal Item Table Body Part -------------------------------------------->
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr [pSelectableRow]="rowData" [pEditableRow]="rowData" (click)="selectRowOnAbnormalItemTable(rowData)">
        <td *ngIf="isInDesktopMode()">
          <p-checkbox
            #rowCheckboxOfAbnormalItemTable
            (click)="stopBubblingPhases($event)"
            (onChange)="toggleRowCheckboxOnAbnormalItemTable($event, rowData)"
            [binary]="true">
          </p-checkbox>
        </td>
        <ng-container [ngSwitch]="col.field" *ngFor="let col of columns">

          <!------------------------------------------ Waiting Reference column --------------------------------------------------->
          <td *ngSwitchCase="'waitingReference'">
            <div class="tableDataTitle-responsive field flex justify-content-between" *ngIf="!isInDesktopMode()">
              <div class="pr-5">{{ col.header | translate }}</div>
              <p-checkbox
                #rowCheckboxOfAbnormalItemTable
                (click)="stopBubblingPhases($event)"
                (onChange)="toggleRowCheckboxOnAbnormalItemTable($event, rowData)"
                [binary]="true">
              </p-checkbox>
            </div>
            <p-cellEditor class="p-fluid">
              <ng-template pTemplate="input">
                <p-dropdown
                  appendTo="body"
                  inputId="abnormalItemTableWaitingReference"
                  placeholder="{{ 'DOAbnormal.Placeholder.OptionHint.SelectAWaitingReference' | translate }}"
                  [showClear]="true"
                  [filter]="true"
                  [options]="waitingReferenceOptions"
                  (click)="stopBubblingPhases($event)"
                  [(ngModel)]="rowData[col.field]"
                ></p-dropdown>
                <small *ngIf="!rowData[col.field]" class="alert">
                  <div class="p-invalid">
                    {{ 'DOAbnormal.Table.AbnormalItem.Toast.Warning.WaitingReferenceRequired' | translate }}
                  </div>
                </small>
              </ng-template>
              <ng-template pTemplate="output">
                <div class="tableData-responsive field overflow-text">
                  {{ getWaitingReferenceDescByItsCode(rowData[col.field]) | replaceNullWith: "-" }}
                </div>
              </ng-template>
            </p-cellEditor>
          </td>

          <!------------------------------------------ Waiting Reference Desc Column --------------------------------------------------->
          <td *ngSwitchCase="'waitingReferenceDesc'">
            <div class="tableDataTitle-responsive field">
              {{ col.header | translate }}
            </div>
            <p-cellEditor class="p-fluid">
              <ng-template pTemplate="input">
                <label for="abnormalItemTableWaitingReferenceDesc"></label>
                <textarea pInputText
                  id="abnormalItemTableWaitingReferenceDesc"
                  rows="5"
                  cols="30"
                  maxlength="4000"
                  (click)="stopBubblingPhases($event)"
                  [(ngModel)]="rowData[col.field]"
                >
                </textarea>
              </ng-template>
              <ng-template pTemplate="output">
                <div class="tableData-responsive field overflow-text" style="white-space: pre-line;">
                  <p style="word-break: break-all;">{{ rowData[col.field] | replaceNullWith: "-" }}</p>
                </div>
              </ng-template>
            </p-cellEditor>
          </td>

          <!------------------------------------------ Abnormal Qty Column --------------------------------------------------->
          <td *ngSwitchCase="'abnormalQty'">
            <div class="tableDataTitle-responsive field">
              {{ col.header | translate }}
            </div>
            <p-cellEditor class="p-fluid">
              <ng-template pTemplate="input">
                <label for="abnormalItemTableAbnormalQty"></label>
                <p-inputNumber
                  [useGrouping]="false"
                  [(ngModel)]="rowData[col.field]"
                ></p-inputNumber>
                <small *ngIf="rowData[col.field] < 0" class="alert">
                  <div class="p-invalid">
                    {{ 'DOAbnormal.Table.AbnormalItem.Toast.Warning.NegativeAbnormalQty' | translate }}
                  </div>
                </small>
              </ng-template>
              <ng-template pTemplate="output">
                <div class="tableData-responsive field overflow-text">
                  {{ rowData[col.field] | replaceNullWith: "-" }}
                </div>
              </ng-template>
            </p-cellEditor>
          </td>

          <!------------------------------------------ File Column --------------------------------------------------->
          <td *ngSwitchCase="'file'">
            <div class="tableDataTitle-responsive field overflow-text">
              {{ col.header | translate }}
            </div>
            <div  class="tableData-responsive field">
              <a *ngIf="rowData['docIds'] && rowData['docIds'].length > 0; else fileUpload"
                href="javascript: void(0);"
                (click)="showAbnormalItemFiles($event, rowData)"
              >
                {{ 'DOAbnormal.Table.AbnormalItem.ColumnData.ShowFile' | translate }}
              </a>
              <ng-template #fileUpload>
                <a *ngIf="rowData.seqNo != -1; else emptyData"
                  href="javascript: void(0);"
                  (click)="showAbnormalItemFiles($event, rowData)"
                >
                  {{ 'DOAbnormal.Table.AbnormalItem.ColumnData.Upload' | translate }}
                </a>
                <ng-template #emptyData>
                  -
                </ng-template>
              </ng-template>
            </div>
          </td>

          <!------------------------------------------ Handle Method Column --------------------------------------------------->
          <td *ngSwitchCase="'handleMethod'">
            <div class="tableDataTitle-responsive field">
              {{ col.header | translate }}
            </div>
            <p-cellEditor class="p-fluid">
              <ng-template pTemplate="input">
                <label for="abnormalItemTableHandleMethod"></label>
                <textarea pInputText
                  id="abnormalItemTableHandleMethod"
                  rows="5"
                  cols="30"
                  maxlength="4000"
                  (click)="stopBubblingPhases($event)"
                  [(ngModel)]="rowData[col.field]"
                >
                </textarea>
              </ng-template>
              <ng-template pTemplate="output">
                <div class="tableData-responsive field overflow-text" style="white-space: pre-line;">
                  <p style="word-break: break-all;">{{ rowData[col.field] | replaceNullWith: "-" }}</p>
                </div>
              </ng-template>
            </p-cellEditor>
          </td>

          <!------------------------------------------ Notes Column --------------------------------------------------->
          <td *ngSwitchCase="'notes'">
            <div class="tableDataTitle-responsive field">
              {{ col.header | translate }}
            </div>
            <p-cellEditor class="p-fluid">
              <ng-template pTemplate="input">
                <label for="abnormalItemTableNotes"></label>
                <textarea pInputText
                  id="abnormalItemTableNotes"
                  rows="5"
                  cols="30"
                  maxlength="4000"
                  (click)="stopBubblingPhases($event)"
                  [(ngModel)]="rowData[col.field]"
                >
                </textarea>
              </ng-template>
              <ng-template pTemplate="output">
                <div class="tableData-responsive field overflow-text" style="white-space: pre-line;">
                  <p style="word-break: break-all;">{{ rowData[col.field] | replaceNullWith: "-" }}</p>
                </div>
              </ng-template>
            </p-cellEditor>
          </td>

          <!------------------------------------------ Default Column --------------------------------------------------->
          <td *ngSwitchDefault>
            <div class="tableDataTitle-responsive field">
              {{ col.header | translate }}
            </div>
            <div class="tableData-responsive field overflow-text">
              {{ rowData[col.field] | replaceNullWith: "-" }}
            </div>
          </td>

        </ng-container>
      </tr>
      <br *ngIf="!isInDesktopMode()">
    </ng-template>

    <!-------------------------------------- Abnormal Item Table Empty Message Part ---------------------------------------------->
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td></td>
        <td [attr.colspan]="columns.length">
          {{ 'Common.Table.NoData' | translate }}
        </td>
      </tr>
    </ng-template>

  </p-table>
</ng-template>

<!-------------------------------------- New Abnormal Item Dialog ---------------------------------------------->
<p-dialog #newAbnormalItemDialog
  header="{{ 'DOAbnormal.Dialog.NewAbnormalItem.Header' | translate }}"
  appendTo="body"
  (visibleChange)="visibleChangeOfNewAbnormalItemDialog($event)"
  [modal]="true"
  [style]="{width: '70vw'}"
  [baseZIndex]="100"
  [draggable]="false"
  [maximizable]="true"
  [closeOnEscape]="false"
  [(visible)]="isShowNewAbnormalItemDialog"
>
  <div *ngIf="isNewAbnormalItemDialogLoading" class="loadingMask">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <div class="grid">

    <!-------------------------------------- Form ---------------------------------------------->
    <div class="col-12 md:col-5">
      <form
        [formGroup]="newAbnormalItemDialogFormGroup"
        (ngSubmit)="0"
      >
        <div class="p-fluid">
          <!-------------------------------------- Abnormal Qty Field ---------------------------------------------->
          <div class="field">
            <h3
              for="dialogAbnormalQty"
              [ngClass]="newAbnormalItemDialogFormGroup.value.abnormalQty >= 0 ? '' : 'p-invalid'"
            >
              {{ 'DOAbnormal.Dialog.NewAbnormalItem.Form.Field.AbnormalQty' | translate }}
            </h3>
            <p-inputNumber
              formControlName="abnormalQty"
              [useGrouping]="false"
            ></p-inputNumber>
            <small *ngIf="newAbnormalItemDialogFormGroup.value.abnormalQty < 0" class="alert">
              <div class="p-invalid">
                {{ 'DOAbnormal.Dialog.NewAbnormalItem.Toast.Warning.NegativeAbnormalQty' | translate }}
              </div>
            </small>
          </div>

          <!-------------------------------------- Waiting Reference Field ---------------------------------------------->
          <div class="field">
            <h3
              for="dialogWaitingReference"
              [ngClass]="newAbnormalItemDialogFormGroup.value.waitingReference ? '' : 'p-invalid'"
            >
              {{ 'DOAbnormal.Dialog.NewAbnormalItem.Form.Field.WaitingReference' | translate }}
            </h3>
            <p-dropdown
              inputId="dialogWaitingReference"
              appendTo="body"
              placeholder="{{ 'DOAbnormal.Placeholder.OptionHint.SelectAWaitingReference' | translate }}"
              formControlName="waitingReference"
              [showClear]="true"
              [filter]="true"
              [options]="waitingReferenceOptions"
              [baseZIndex]="1000"
            ></p-dropdown>
          </div>

          <!-------------------------------------- Waiting Reference Desc Field ---------------------------------------------->
          <div class="field">
            <h3>{{ 'DOAbnormal.Dialog.NewAbnormalItem.Form.Field.WaitingReferenceDesc' | translate }}</h3>
            <label for="dialogWaitingReferenceDesc"></label>
            <textarea pInputTextarea
              id="dialogWaitingReferenceDesc"
              style="resize: none;"
              rows="7"
              formControlName="waitingReferenceDesc"
            ></textarea>
          </div>
        </div>
      </form>
    </div>

    <!-------------------------------------- File Table ---------------------------------------------->
    <div class="col-12 md:col-7 field">
      <h3>{{ 'DOAbnormal.Dialog.NewAbnormalItem.Table.File.Header' | translate }}</h3>
      <label [ngClass]="'p-invalid'">{{ 'DOAbnormal.Dialog.NewAbnormalItem.Table.File.Warn' | translate }}</label>
      <p-table #fileTable
        [columns]="columnGroupOfFileTable"
        [value]="dataOfFileTable"
        [resizableColumns]="true"
        [reorderableColumns]="true"

        [scrollable]="true"
        scrollHeight="500px"

        [paginator]="true"
        [paginatorPosition]="isInDesktopMode() ? 'bottom': 'top'"
        [showJumpToPageDropdown]="true"
        [showPageLinks]="false"
        [showFirstLastIcon]="isInDesktopMode()"
        [rows]="3"

        [responsive]="true"
        dataKey="dataKey"
        baseZIndex="1020"
        class="datatable"
        styleClass="p-datatable-gridlines p-datatable-stripped white-space: nowrap;"
      >
        <!-------------------------------------- File Table Caption Part ---------------------------------------------->
        <ng-template pTemplate="caption">
          <div class="caption flex flex-wrap justify-content-start">

            <!-------------------------------------- Choose File Button -------------------------------------->
            <div>
              <label
                class="p-button p-component p-fileupload-choose"
              >
                <i *ngIf="isInDesktopMode()"class="pi pi-plus" aria-hidden="true" [ngClass]="'p-button-icon p-button-icon-left'"></i>
                {{ 'DOAbnormal.Dialog.NewAbnormalItem.Table.File.Button.ChooseFile' | translate }}

                <input #newAbnormalItemfileInput
                  style="display:none"
                  type="file"
                  multiple="true"
                  (input)="onNewFileFileSelect(newAbnormalItemfileInput)"
                >
              </label>
            </div>
          </div>
        </ng-template>

        <!-------------------------------------- File Table Column Group Part ---------------------------------------------->
        <ng-template pTemplate="colgroup" let-columns>
          <colgroup *ngIf="isInDesktopMode()">
            <col *ngFor="let col of columns" style="width: 15vw">
          </colgroup>
        </ng-template>

        <!-------------------------------------- File Table Column Header Part ---------------------------------------------->
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" pReorderableColumn pResizableColumn
              [pSortableColumn]="col.field"
              [pSortableColumnDisabled]="!col.sort"
              scope="col"
            >
              {{ col.header | translate }}
            </th>
          </tr>
        </ng-template>

        <!------------------------------------------- File Table Body Part -------------------------------------------->
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
          <tr>
            <ng-container [ngSwitch]="col.field" *ngFor="let col of columns">

              <!-------------------------------------- File Name Column ---------------------------------------------->
              <td *ngSwitchCase="'fileName'">
                <div class="tableDataTitle-responsive field flex justify-content-between" *ngIf="!isInDesktopMode()">
                  <div class="pr-5">{{ col.header | translate }}</div>
                  <button pButton
                    type="button"
                    icon="pi pi-times"
                    class="p-button-small p-button-rounded p-button-danger p-button-text"
                    (click)="removeChosenFile(rowIndex)"
                  ></button>
                </div>
                <div class="tableData-responsive field flex align-items-center">
                  <div *ngIf="isInDesktopMode()">
                    <button pButton
                      type="button"
                      icon="pi pi-times"
                      class="p-button-small p-button-rounded p-button-danger p-button-text"
                      (click)="removeChosenFile(rowIndex)"
                    ></button>
                  </div>
                  <div class="overflow-text">
                    {{ rowData['name'] | replaceNullWith: "-" }}
                  </div>
                </div>
              </td>
            </ng-container>
          </tr>
          <br *ngIf="!isInDesktopMode()">
        </ng-template>

        <!-------------------------------------- File Table Empty Message Part ---------------------------------------------->
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'Common.Table.NoData' | translate }}
            </td>
          </tr>
        </ng-template>

      </p-table>
    </div>
  </div>

  <!-------------------------------------- Related Detail Table ---------------------------------------------->
  <div>
    <h3>{{ 'DOAbnormal.Dialog.NewAbnormalItem.Table.RelatedDetail.Header' | translate }}</h3>
    <p-table #relatedDetailTable
      [columns]="selectedColumnsOfRelatedDetailTable"
      [value]="dataOfRelatedDetailTable"
      [resizableColumns]="true"
      [reorderableColumns]="true"

      [scrollable]="true"
      scrollHeight="500px"

      [paginator]="true"
      [paginatorPosition]="isInDesktopMode() ? 'bottom': 'top'"
      [showJumpToPageDropdown]="!isInDesktopMode()"
      [showPageLinks]="isInDesktopMode()"
      [showFirstLastIcon]="isInDesktopMode()"
      [rows]="this.pageInfoOfDetailTable.pageSize"

      [responsive]="true"
      dataKey="dataKey"
      class="datatable"
      styleClass="p-datatable-gridlines p-datatable-stripped white-space: nowrap;"
    >
      <!-------------------------------------- Related Detail Table Caption Part ---------------------------------------------->
      <ng-template pTemplate="caption" >
        <div class="caption">

          <!-------------------------------------- Related Detail Table Display Columns Filter ---------------------------------------------->
          <div *ngIf="isInDesktopMode()">
            <laas-table-column-toggle
              [optionsColumn]="columnGroupOfRelatedDetailTable"
              [dataTable]="relatedDetailTable">
            </laas-table-column-toggle>
          </div>

          <!-------------------------------------- Related Detail Table Select All Button ---------------------------------------------->
          <div *ngIf="!isInDesktopMode()">
            <button pButton
              class="p-button-info p-button-raised"
              label="{{ 'DOAbnormal.Table.Button.SelectAll' | translate }}"
              [ngClass]="!isInDesktopMode() ? '' : 'p-button ml-2'"
              (click)="toggleAllRowCheckboxOnRelatedDetailTable()"
            ></button>
          </div>

        </div>
      </ng-template>

      <!-------------------------------------- Related Detail Table Column Group Part ---------------------------------------------->
      <ng-template pTemplate="colgroup" let-columns>
        <colgroup *ngIf="isInDesktopMode()">
          <col style="width: 50px;">
          <col *ngFor="let col of columns" style="width: 15vw">
        </colgroup>
      </ng-template>

      <!-------------------------------------- Related Detail Table Column Header Part ---------------------------------------------->
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th scope="col">
            <p-checkbox
              #headerCheckboxOfRelatedDetailTable
              (click)="toggleAllRowCheckboxOnRelatedDetailTable()"
              [binary]="true">
            </p-checkbox>
          </th>
          <th *ngFor="let col of columns" pReorderableColumn pResizableColumn
            [pSortableColumn]="col.field"
            [pSortableColumnDisabled]="!col.sort"
            scope="col"
          >
            {{ col.header | translate }}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>

      <!------------------------------------------- Related Detail Table Body Part -------------------------------------------->
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr>

          <td *ngIf="isInDesktopMode()">
            <p-checkbox
              #rowCheckboxOfRelatedDetailTable
              (click)="stopBubblingPhases($event)"
              (onChange)="toggleRowCheckboxOnRelatedDetailTable($event, rowData)"
              [binary]="true">
            </p-checkbox>
          </td>

          <ng-container [ngSwitch]="col.field" *ngFor="let col of columns">

            <!-------------------------------------- SKU Column ---------------------------------------------->
            <ng-container *ngIf="!isInDesktopMode()">
              <td *ngSwitchCase="'sku'">
                <div class="tableDataTitle-responsive field flex justify-content-between">
                  <div class="pr-5">{{ col.header | translate }}</div>
                  <p-checkbox
                    #rowCheckboxOfRelatedDetailTable
                    (click)="stopBubblingPhases($event)"
                    (onChange)="toggleRowCheckboxOnRelatedDetailTable($event, rowData)"
                    [binary]="true">
                  </p-checkbox>
                </div>
                <div class="tableData-responsive field overflow-text">
                  {{ rowData[col.field] | replaceNullWith: "-" }}
                </div>
              </td>
            </ng-container>

            <td *ngSwitchDefault>
              <div class="tableDataTitle-responsive field">
                {{ col.header | translate }}
              </div>
              <div class="tableData-responsive field overflow-text">
                {{ rowData[col.field] | replaceNullWith: "-" }}
              </div>
            </td>

          </ng-container>
        </tr>
        <br *ngIf="!isInDesktopMode()">
      </ng-template>

      <!-------------------------------------- Related Detail Table Empty Message Part ---------------------------------------------->
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td></td>
          <td [attr.colspan]="columns.length">
            {{ 'Common.Table.NoData' | translate }}
          </td>
        </tr>
      </ng-template>

    </p-table>
  </div>

  <!--------------------------------------- Dialog Footer ---------------------------------------->
  <ng-template pTemplate="footer">
    <button pButton
      class="p-button-raised mt-2"
      label="{{ 'Common.Button.Save' | translate }}"
      (click)="createNewAbnormalItem()"
    ></button>
  </ng-template>

</p-dialog>

<!-------------------------------------- Abnormal Item File Dialog ---------------------------------------------->
<p-dialog #abnormalItemFileDialog
  header="{{ 'DOAbnormal.Dialog.AbnormalItemFile.Header' | translate }}"
  appendTo="body"
  (visibleChange)="visibleChangeOfAbnormalItemFileDialog($event)"
  [modal]="true"
  [style]="{width: '70vw'}"
  [baseZIndex]="100"
  [draggable]="false"
  [maximizable]="true"
  [closeOnEscape]="false"
  [(visible)]="isShowAbnormalItemFileDialog"
>

  <div *ngIf="isAbnormalItemFileDialogLoading" class="flex justify-content-center">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <ng-template pTemplate="header">
    <label [ngClass]="'p-invalid'" style="margin-left: 30px;">{{ 'DOAbnormal.Dialog.NewAbnormalItem.Table.File.Warn' | translate }}</label>
    <div class='abnormalItemFileDialogModeSwitch' >
      <p-radioButton
        class="mr-2"
        label="{{ 'DOAbnormal.Dialog.AbnormalItemFile.Mode.Edit' | translate }}"
        name="abnormalItemFileDialogMode"
        [value]="ABNORMAL_ITEM_FILE_DIALOG_MODE_ENUM.Edit"
        [(ngModel)]="abnormalItemFileDialogMode">
      </p-radioButton>

      <p-radioButton
        label="{{ 'DOAbnormal.Dialog.AbnormalItemFile.Mode.Download' | translate }}"
        name="abnormalItemFileDialogMode"
        [value]="ABNORMAL_ITEM_FILE_DIALOG_MODE_ENUM.Download"
        [(ngModel)]="abnormalItemFileDialogMode">
      </p-radioButton>
    </div>
    <div>
      <button class='p-dialog-header-icon' (click)="restoreAbnormalItemFileData()" pRipple>
        <span class="pi pi-refresh"></span>
      </button>
    </div>
  </ng-template>

  <div class="flex flex-wrap justify-content-start"  *ngIf="!isAbnormalItemFileDialogLoading">

    <ng-container *ngIf="isAbnormalItemFileDialogInEditMode()">
      <label class='abnormal-item-file-add-btn' pRipple>
        <span class="pi pi-plus"></span>
        <input #abnormalItemFilefileInput
          style="display:none"
          type="file"
          multiple="true"
          (input)="addFileToAbnormalItem(abnormalItemFilefileInput)"
        >
      </label>
    </ng-container>

    <div *ngFor="let file of fileOfAbnormalItemFileDialog; let index = index">
      <div class="abnormal-item-file-block">

        <ng-container *ngIf="isAbnormalItemFileDialogInEditMode() else downloadModeTemplate">
          <img *ngIf="isImageTypeFile(file.fileType!); else editableFileIconTemplate"
            [alt]="file.fileName + '.' + file.fileExtension"
            [src]="transformToSafeUrl(file.fileDataUrl)"
            (click)="onFileClick(index)"
          />
          <ng-template #editableFileIconTemplate>
            <span class="abnormal-item-normal-file-icon pi pi-file-o"></span>
          </ng-template>

          <button *ngIf="filePermission" class='p-dialog-header-icon' (click)="deleteFileFromAbnormalItem(index)" pRipple>
            <span class="pi pi-times-circle"></span>
          </button>
        </ng-container>

        <ng-template #downloadModeTemplate>
          <a
            [href]="transformToSafeUrl(file.fileDataUrl)"
            [download]="file.fileName + '.' + file.fileExtension"
          >
            <span class="download-mask pi pi-download"></span>
          </a>

          <img *ngIf="isImageTypeFile(file.fileType!); else downloadableFileIconTemplate"
            [alt]="file.fileName + '.' + file.fileExtension"
            [src]="transformToSafeUrl(file.fileDataUrl)"
          />
          <ng-template #downloadableFileIconTemplate>
            <span class="abnormal-item-normal-file-icon pi pi-file-o"></span>
          </ng-template>

          <button *ngIf="filePermission" class='p-dialog-header-icon' (click)="deleteFileFromAbnormalItem(index)" pRipple>
            <span class="pi pi-times-circle"></span>
          </button>
        </ng-template>

      </div>

      <div class="abnormal-item-file-name-block">
        <p>{{file.fileName}}.{{file.fileExtension}}</p>
      </div>

    </div>
  </div>

  <p-galleria
    (visibleChange)="visibleChangeOfGalleria()"
    [value]="fileOfAbnormalItemFileDialog"
    [(activeIndex)]="indexOfGalleria"
    [containerStyle]="{'max-width': '80vw'}"
    [circular]="true"
    [fullScreen]="true"
    [showItemNavigators]="true"
    [showThumbnails]="false"
    [baseZIndex]="1000"
    [transitionInterval]="0"
    [(visible)]="isShowBigFile"
  >
    <ng-template pTemplate="item" let-item>
      <img *ngIf="isImageTypeFile(item.fileType); else notImageFileTemplate"
        [src]="transformToSafeUrl(item.fileDataUrl)"
        [alt]="item.fileName + '.' + item.fileExtension"
        style="width: 100%; height: 100%; display: block;"
      />
      <ng-template #notImageFileTemplate>
        <span style="color: white">
          {{item.fileName + '.' + item.fileExtension}} is not a image file
        </span>
      </ng-template>
    </ng-template>
  </p-galleria>

  <ng-template pTemplate="footer">
    <button pButton
      class="p-button-raised mt-2"
      label="{{ 'Common.Button.Save' | translate }}"
      [disabled]="!isAbleToSaveAbnormalItemFileChange()"
      (click)="onSaveBtnClickOnAbnormalItemFileDialog()"
    ></button>
  </ng-template>
</p-dialog>
<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
